export default {
    settings: 'settings',
    userSettings: 'userSettings',
    help: 'help',
    botAdmin: 'botAdmin',
    newMessageModal: 'newMessageModal',
    notificationExample: 'notificationExample',
    mobileDrawer: 'mobileDrawer',
    contact: 'contact',
};
